import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Actions} from '../../../../common/actions';
import ShiftForm from './form';
import './editShift.scss';

class EditShift extends Component {
  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit(formValues) {
    const {code} = this.props;
    if (code) {
      return this.props.editShift(code, formValues);
    }
    return this.props.addShift(formValues);
  }

  render() {
    const {code, goBack, push} = this.props;

    return (
      <ShiftForm
        goBack={goBack}
        push={push}
        code={code}
        onSubmit={this.onSubmit}
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const {code} = ownProps.params;
  return {
    code,
    'goBack': ownProps.history.goBack,
    'push': ownProps.history.push,
  };
};

const {addShift, editShift, withRouter} = Actions;

export default withRouter(
  connect(mapStateToProps, {
    addShift,
    editShift,
  })(EditShift)
);
